import React, { forwardRef } from 'react';
// import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box, MinervaProps, systemProps } from '../layout';
import { ForwardRefComponent } from '../utilities/polymorphic';

export const TableContainer = styled.div`
  border-radius: 8px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  overflow: auto;
`;

// export const StyledTable = styled(Box)(
//   {
//     // backgroundColor: '#525252',

//     minWidth: '100%',
//     borderCollapse: 'collapse',
//   },
//   systemProps
// );

export const StyledTable = React.forwardRef(function StyledTable(
  props: any,
  ref: any
) {
  return (
    <Box
      as="table"
      ref={ref}
      margin={0}
      minWidth="100%"
      borderCollapse="collapse"
      display="table"
      {...props}
    />
  );
}) as ForwardRefComponent<any, 'table'>;

export const TableHeader = styled('thead')(
  {
    // backgroundColor: '#6b7280',
  },
  systemProps
);

export const TableFooter = styled('thead')(
  {
    // backgroundColor: '#6b7280',
  },
  systemProps
);

export const TableBody = styled('tbody')(
  {
    // backgroundColor: '#6b7280',
  },
  systemProps
);

export const TableHeaderCell = styled('th')(
  {
    padding: '12px 24px',
    color: '#6b7280',
    backgroundColor: '#f9fafb',
    textTransform: 'uppercase',
    fontWeight: 500,
    fontSize: '12px',
    letterSpacing: '0.6px',
    textAlign: 'left',
    border: 0,
    borderBottom: '1px solid #e5e7eb',
  },
  systemProps
);

export const TableCell = styled('td')(
  {
    padding: '16px 24px',
    color: '#161e2e',
    backgroundColor: '#fff',
    fontSize: '14px',
    border: 0,
    borderBottom: '1px solid #e5e7eb',
  },
  systemProps
);

export const TableRow = styled('tr')(
  {
    border: 0,
  },
  systemProps
);

export interface CustomTableProps
  extends React.HTMLAttributes<HTMLTableElement> {
  children?: React.ReactNode;
}

export type Ref = HTMLTableElement;

export const Table = forwardRef<Ref, CustomTableProps & MinervaProps>(
  ({ children, ...props }, ref) => {
    return (
      <TableContainer>
        <Box
          as="table"
          ref={ref}
          margin={0}
          minWidth="100%"
          borderCollapse="collapse"
          display="table"
          {...props}
        >
          {children}
        </Box>
      </TableContainer>
    );
  }
);

Table.displayName = 'Table';

export default Table;

// if (__DEV__) {
//   Table.propTypes = {
//     children: PropTypes.node,
//   };
// }
